// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li[data-v-443a1039]{background:black}.uk-navbar-nav>li>a.cart-button[data-v-443a1039]{color:white}.amount[data-v-443a1039]{padding-left:3px}.cart-summary[data-v-443a1039]{display:flex;flex-direction:column;max-height:100%;min-height:100%}.cart-summary[data-v-443a1039] .small-cart-overview{overflow:auto;flex-grow:1;border-top:1px #f4f4f4 solid;border-bottom:1px #f4f4f4 solid}\n", ""]);
// Exports
module.exports = exports;
